module.exports = __webpack_public_path__ + "static/hero-gdpr-739123cce31f62d5b0049bffd1f88c08.jpg";